import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from "@components/index";
import { Log } from "ng2-logger";
import { TreeModel } from "@components/tree/tree.model";
import { IssuesService } from '@app/core/services/issues.service';
import { TableConfig } from '@app/shared/util/table-config.utils';

@Component({
    selector: 'app-tool-reset-modal',
    templateUrl: './tool-reset-modal.component.html',
    styleUrls: ['./tool-reset-modal.component.scss']
})
export class ToolResetModalComponent implements OnInit {
    _logger = Log.create(ToolResetModalComponent.name);

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Input() selectedTool;

    @Output() onRowAlertClicked = new EventEmitter();
    @Output() resetTool = new EventEmitter();

    scannedTools = [];
    isResetFormValid = false;
    isScanListenerActive;

    shouldOpen = false;
    // TODO this shouldn't be used. We should find a cleaner way of handling the tool scenario
    isToolScanned = false;
    loading = false;

    constructor(private issueService: IssuesService) {
    }

    ngOnInit() {
    }

    open() {
        this.isScanListenerActive = true;
        this.shouldOpen = true;
        this.scannedTools = [this.selectedTool];
        this.modal.open();
    }

    close() {
        this.isScanListenerActive = false;
        this.shouldOpen = false;
        this.modal.close();
    }

    onResetFormStatus(event) {
        this.isResetFormValid = event;
    }

    toolWasScanned(event) {
        this.isToolScanned = true;
        this.getToolIssue(this.selectedTool.id);
    }

    rowAlertClicked(node: TreeModel) {
        this.onRowAlertClicked.emit(node);
    }

    getToolIssue(toolID: number) {
        this.loading = true;
        this._logger.info('getToolIssue:: Fetching tool issue for tool with ID', toolID);
        const config = new TableConfig();
        config.filters[0] = { field: 'isNew', value: true};
        config.filters[1] = { field: 'toolId', value: this.selectedTool.id};
        this.issueService.getAllIssues(config).subscribe(
            (data: any) => {
                if (data && data.items && data.items.length > 0) {
                    this.issueService.getIssueById(data.items[0].id).subscribe(
                        issue => {
                            this.loading = false;
                            this.selectedTool.issue = issue;
                            this.selectedTool.isScanned = this.isToolScanned;
                            this.scannedTools = [this.selectedTool];
                            this._logger.info('getToolIssue:: API returned data', data);
                        },
                        error => {
                            this.loading = false;
                            this._logger.error('getToolIssue:: API returned error', error);
                        }
                    );

                } else {
                    this.loading = false;
                }
                this._logger.info('getToolIssues:: API returned data', data)
            },
            (error) => {
                this.loading = false;
                this._logger.error('getToolIssues:: API returned error', error);
            }
        )
    }

    onResetTool() {
        this.resetTool.emit();
    }

}
